/* Disabling the following linting - due to this bug https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/477 */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './B16-filter.scss';

import AddressCard from './components/address-card';

class B16Filter extends Component {
	constructor(props) {
		super(props);

		this.setLocation = this.setLocation.bind(this);
		this.renderOption = this.renderOption.bind(this);

		this.state = {
			currentLocationId: '',
		};
	}

	setLocation(evt) {
		const { value: currentLocationId } = evt.currentTarget;
		this.setState({ currentLocationId });
	}

	renderOption = (location) => {
		return (
			<option key={location.id} value={location.id}>{location.name}</option>
		);
	}

	render() {
		const {
			data,
			filterSubject,
			filterType,
			filterDefault,
		} = this.props;

		const { currentLocationId } = this.state;
		let { addresses } = data;

		if (currentLocationId !== '') {
			addresses = data.addresses.filter((address) => { return address.locationId === currentLocationId; });
		}

		return (
			<React.Fragment>
				<div className="container B16-filter__header">
					<div className="select-group">
						<label className="select-label" htmlFor="countryFilter">{filterType}</label>
						<div className="select-wrapper">
							<select value={currentLocationId} className="select" name="countryFilter" id="countryFilter" onChange={this.setLocation}>
								<option value="">{filterDefault}</option>
								{data.locations.map(this.renderOption)}
							</select>
						</div>
					</div>
				</div>
				<div className="container">
					<h2 className="B16-filter__subject-header">{filterSubject}</h2>
					<div className="B16-filter__card-container">
						{addresses.map((address) => { return (<AddressCard key={address.id} address={address} />); })}
					</div>
				</div>
			</React.Fragment>
		);
	}
}

B16Filter.defaultProps = {
	data: {},
};

B16Filter.propTypes = {
	data: PropTypes.shape({}),
	filterSubject: PropTypes.string.isRequired,
	filterType: PropTypes.string.isRequired,
	filterDefault: PropTypes.string.isRequired,
};

export default B16Filter;
